module.exports = __webpack_public_path__ + "img/breathing-awful.569632de.svg";